module.exports = __webpack_public_path__ + "img/tab.ce2f1110.svg";